import { createFileRoute, Outlet } from '@tanstack/react-router'

import { requireGlobalUser } from 'lib/routeGuards'

export const Route = createFileRoute('/_auth/_global')({
  beforeLoad: requireGlobalUser,
  component: () => <Outlet />,
})
